import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { setSnackbar } from 'shared/store/slices/snackBarSlice';

/**
 * Returns a callback that warns the user (via snackbar) when a pasted value
 * is not one of the allowed select options.
 */
const useInvalidOptionWarning = () => {
    const dispatch = useDispatch();

    return useCallback(
        (value) => {
            dispatch(
                setSnackbar({
                    open: true,
                    message: `"${value}" is not a valid option.`,
                    severity: 'warning',
                }),
            );
        },
        [dispatch],
    );
};

export default useInvalidOptionWarning;
